import React from "react";
import SavvytronHeader from "../components/SavvytronHeader";
import BookingCalendar from "../components/BookingCalendar";
import AppointmentForm from "../components/AppointmentForm";
import ContactSection from "../components/ContactSection";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ContactPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#book") {
      const el = document.getElementById("book");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [hash]);



  return (
    <>
      <SavvytronHeader />

      <div className="max-w-5xl mx-auto p-6 mt-10">


        <div id="book" className="mt-12">
          <BookingCalendar />
        </div>
        <br />

        <ContactSection />

        <div id ="message" className="mt-12">
        <AppointmentForm />
        </ div>


        {/* Footer */}
        <footer className="flex flex-col gap-4 mt-8 border-t border-gray-200 pt-6 text-sm text-gray-700 md:flex-row md:justify-between">
          <div className='mb-4 md:mb-0'>
            <p><strong>Email:</strong> contact@savvytron.com</p>
            <p><strong>Location:</strong> Based in Dallas, TX – Available remotely or in-person</p>
            <p><strong>Hours:</strong> Mon–Sat, 10 AM to 6 PM</p>
          </div>

          <div className="md:self-center">
            <a
              href="/login"
              className="
                         w-full sm:w-auto
                          inline-flex items-center justify-center
                        px-6 py-2.5
                             rounded-lg
                                    bg-brand/10           /* 10 % tint of brand colour */
                           text-brand
    font-medium
    transition
    hover:bg-brand/20
    active:bg-brand/25
    focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40
    text-sm sm:text-base
  "
            >
              Client&nbsp;login
            </a>

          </div>



        </footer>
      </div>
      {/* 

        <h2 className="text-center text-gray-400 font-copperplate text-s">
          Chumma !! 😉
        </h2> */}
    </>
  );
}
